(function () {
    function getVariantsData() {
        const variantJsonEl = document.getElementById("cod-product-variants-json") ||
            document.querySelector(".product-variants-data") ||
            document.getElementById("product-variants-json");

        if (variantJsonEl) {
            try {
                return JSON.parse(variantJsonEl.textContent);
            } catch (e) {
                console.error("Failed to parse variants JSON", e);
            }
        }
        return [];
    }

    function getSelectedOptionValues() {
        const selected = [];

        // Check radio buttons
        const radioGroups = document.querySelectorAll(".product-options-buttons .product-option-radio");
        if (radioGroups.length > 0) {
            radioGroups.forEach(group => {
                const checked = group.querySelector(".option_input:checked");
                if (checked) {
                    selected.push(String(checked.value).trim());
                }
            });
            if (selected.length === radioGroups.length) return selected;
            return [];
        }

        // Check dropdown selects
        const selectGroups = document.querySelectorAll(".product-options-selector .single_selector, .product-option-select .single_selector");
        if (selectGroups.length > 0) {
            selectGroups.forEach(sel => {
                if (sel.value) selected.push(String(sel.value).trim());
            });
            if (selected.length === selectGroups.length) return selected;
            return [];
        }

        return selected;
    }

    function requiresSelection() {
        return document.querySelector('[data-requires-variant-selection="true"]') !== null;
    }

    function getCODButtons() {
        return document.querySelectorAll('[data-buy-now], [data-cod-buy-now], .cod-buy-now-button, .cod-buy-now-popup__trigger, .custom-buy-now-btn');
    }

    function isCheckoutButtonEvent(event) {
        return event.composedPath().some(element => {
            return element instanceof Element && (
                element.matches('.shopify-payment-button, shopify-accelerated-checkout') ||
                element.matches('[data-buy-now], [data-cod-buy-now], .cod-buy-now-button, .cod-buy-now-popup__trigger, .custom-buy-now-btn')
            );
        });
    }

    function setCODReady(ready) {
        getCODButtons().forEach(button => {
            button.classList.toggle('zuqo-cod-needs-size', !ready);
            button.setAttribute('aria-disabled', ready ? 'false' : 'true');
        });
    }

    function showSelectionError() {
        const options = document.querySelector('.product-options-buttons, .product-options-selector');
        if (!options) return;
        let message = document.querySelector('.zuqo-size-reminder');
        if (!message) {
            message = document.createElement('p');
            message.className = 'zuqo-size-reminder';
            message.setAttribute('role', 'alert');
            message.textContent = window.zuqoSelectSizeMessage || 'Please select a size first';
            options.insertAdjacentElement('afterend', message);
        }
        message.classList.remove('is-visible');
        void message.offsetWidth;
        message.classList.add('is-visible');
        options.classList.remove('zuqo-size-attention');
        void options.offsetWidth;
        options.classList.add('zuqo-size-attention');
        options.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function disableUnavailableOptions(variants) {
        document.querySelectorAll('.option_input').forEach(input => {
            const index = Number(input.dataset.optionIndex || 0);
            const available = variants.some(variant => variant.available && String(variant.options[index]) === String(input.value));
            input.disabled = !available;
            input.closest('.option-item')?.classList.toggle('is-sold-out', !available);
        });
        document.querySelectorAll('.single_selector').forEach(select => {
            const index = Number(select.dataset.optionIndex || 0);
            Array.from(select.options).forEach(option => {
                if (!option.value) return;
                option.disabled = !variants.some(variant => variant.available && String(variant.options[index]) === String(option.value));
            });
        });
    }

    function findMatchingVariant(selectedOptions, variants) {
        if (!selectedOptions || !selectedOptions.length) return null;

        if (variants && variants.length) {
            const matched = variants.find(v => {
                if (Array.isArray(v.options) && v.options.length) {
                    return selectedOptions.every((opt, index) => {
                        return String(v.options[index] || '').trim().toLowerCase() === String(opt || '').trim().toLowerCase();
                    });
                }
                return false;
            });
            if (matched) return matched;
        }

        // Fallback: match from #productSelect options
        let optionMatched = null;
        const joinedTitle = selectedOptions.join(" / ").trim().toLowerCase();

        const selectOptions = document.querySelectorAll('#productSelect option');
        selectOptions.forEach(opt => {
            const optTitle = String(opt.getAttribute('data-title') || opt.textContent).trim().toLowerCase();
            const opt1 = String(opt.getAttribute('data-option1') || '').trim().toLowerCase();
            const opt2 = String(opt.getAttribute('data-option2') || '').trim().toLowerCase();
            const opt3 = String(opt.getAttribute('data-option3') || '').trim().toLowerCase();

            let matches = false;
            if (selectedOptions.length === 1 && opt1 === selectedOptions[0].toLowerCase()) {
                matches = true;
            } else if (selectedOptions.length === 2 && opt1 === selectedOptions[0].toLowerCase() && opt2 === selectedOptions[1].toLowerCase()) {
                matches = true;
            } else if (selectedOptions.length === 3 && opt1 === selectedOptions[0].toLowerCase() && opt2 === selectedOptions[1].toLowerCase() && opt3 === selectedOptions[2].toLowerCase()) {
                matches = true;
            } else if (optTitle === joinedTitle) {
                matches = true;
            }

            if (matches && !optionMatched) {
                optionMatched = {
                    id: opt.value,
                    title: opt.getAttribute('data-title') || opt.textContent.trim(),
                    price: opt.getAttribute('data-price'),
                    compare_at_price: opt.getAttribute('data-compare'),
                    available: opt.getAttribute('data-available') === 'true' || opt.getAttribute('data-available') === true
                };
            }
        });

        return optionMatched;
    }

    function getShippingAmount() {
        const shippingRadio = document.querySelector('.cod-bn-delivery-options input[type="radio"]:checked');
        return shippingRadio ? Number(shippingRadio.value || 0) / 100 : 0;
    }

    function updateCODState(variant) {
        if (!variant || !variant.id) return;

        const variantId = String(variant.id);
        const variantTitle = variant.title || "";
        const rawPrice = Number(variant.price || 0);
        const normalizedPrice = rawPrice >= 100 ? rawPrice / 100 : rawPrice;

        // Update popup product rows
        const rows = document.querySelectorAll("[data-selected-product-row]");
        rows.forEach(row => {
            row.setAttribute("data-variant-id", variantId);

            const hidden = row.querySelector('input[name="id"]');
            if (hidden) {
                hidden.value = variantId;
                hidden.setAttribute("value", variantId);
                hidden.dispatchEvent(new Event("change", { bubbles: true }));
            }

            const variantText = row.querySelector(".cod-buy-now-popup__product-variant");
            if (variantText) {
                variantText.textContent = variantTitle;
                variantText.style.display = "";
            }

            const qtyInput = row.querySelector("[data-selected-product-quantity-input]");
            const qty = Math.max(1, Number(qtyInput?.value || 1));

            const subtotal = normalizedPrice * qty;
            const total = subtotal + getShippingAmount();

            const priceText = row.querySelector("[data-price-display]");
            if (priceText && normalizedPrice > 0) {
                priceText.textContent = normalizedPrice.toFixed(2);
            }

            const subtotalText = document.querySelector("[data-subtotal-display]");
            if (subtotalText && normalizedPrice > 0) {
                subtotalText.textContent = subtotal.toFixed(2);
            }

            const totalText = document.querySelector("[data-total-display]");
            if (totalText && normalizedPrice > 0) {
                totalText.textContent = total.toFixed(2);
            }
        });

        // Update COD confirm button
        const confirmBtns = document.querySelectorAll("[data-buy-now-confirm]");
        confirmBtns.forEach(btn => {
            btn.setAttribute("data-variant-gid", "gid://shopify/ProductVariant/" + variantId);
        });
    }

    function onVariantChange() {
        const variants = getVariantsData();
        const selectedOptions = getSelectedOptionValues();
        const variant = findMatchingVariant(selectedOptions, variants);

        if (!variant || !(variant.available === true || variant.available === "true")) {
            setCODReady(!requiresSelection());
            return;
        }

        const variantId = String(variant.id);

        // Update select#productSelect
        const productSelect = document.getElementById("productSelect");
        if (productSelect) {
            productSelect.value = variantId;
            if (window.jQuery) {
                window.jQuery(productSelect).val(variantId);
            }
        }

        // Update all product form inputs with name="id" and dispatch native change/input events
        const inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], #product_id');
        inputs.forEach(input => {
            input.value = variantId;
            input.setAttribute("value", variantId);
            input.dispatchEvent(new Event("change", { bubbles: true }));
            input.dispatchEvent(new Event("input", { bubbles: true }));
        });

        // Update add to cart buttons
        const isAvailable = variant.available === true || variant.available === "true";
        const btn = document.querySelector('.product-btn');
        if (btn) {
            if (isAvailable) {
                btn.classList.remove('sold_out');
                btn.removeAttribute('disabled');
                btn.textContent = 'Add To Cart';
            } else {
                btn.classList.add('sold_out');
                btn.setAttribute('disabled', 'disabled');
                btn.textContent = 'Sold Out';
            }
        }

        // Update URL
        if (window.history && window.history.replaceState) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', variantId);
            window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
        }

        // Sync with COD popup
        updateCODState(variant);
        setCODReady(true);
        document.querySelector('.zuqo-size-reminder')?.classList.remove('is-visible');
        document.querySelector('.product-options-buttons, .product-options-selector')?.classList.remove('zuqo-size-attention');
    }

    // Initialize event listeners
    function init() {
        const variants = getVariantsData();
        if (requiresSelection()) {
            document.querySelectorAll('.option_input:checked').forEach(input => { input.checked = false; });
            document.querySelectorAll('.single_selector').forEach(select => { select.selectedIndex = 0; });
            const productSelect = document.getElementById('productSelect');
            if (productSelect) productSelect.selectedIndex = -1;
            document.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], #product_id').forEach(input => { input.value = ''; });
            disableUnavailableOptions(variants);
            setCODReady(false);
        }

        document.addEventListener('click', function (e) {
            if (!isCheckoutButtonEvent(e) || !requiresSelection()) return;
            const selectedOptions = getSelectedOptionValues();
            const variant = findMatchingVariant(selectedOptions, getVariantsData());
            if (!variant || !(variant.available === true || variant.available === 'true')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                showSelectionError();
            }
        }, true);
        document.addEventListener("change", function (e) {
            if (
                e.target.matches(".option_input") ||
                e.target.matches(".single_selector") ||
                e.target.matches("[data-selected-product-quantity-input]") ||
                e.target.matches('.cod-bn-delivery-options input[type="radio"]')
            ) {
                onVariantChange();
            }
        }, true);

        document.addEventListener("click", function (e) {
            if (
                e.target.closest(".product-options-buttons label") ||
                e.target.closest(".option-item") ||
                e.target.closest("[data-buy-now], [data-cod-buy-now], .cod-buy-now-button, .cod-buy-now-popup__trigger, .custom-buy-now-btn, button[name='add']")
            ) {
                onVariantChange();
                setTimeout(onVariantChange, 60);
                setTimeout(onVariantChange, 200);
            }

            // Quantity selector buttons
            if (e.target.closest('.product-qty-plus')) {
                const btn = e.target.closest('.product-qty-plus');
                const input = btn.parentElement ? btn.parentElement.querySelector('.product-input-qty') : null;
                if (input) {
                    let qty = parseInt(input.value) || 1;
                    qty += 1;
                    input.value = qty;
                    const hiddenQty = document.getElementById('product_qty');
                    if (hiddenQty) hiddenQty.value = qty;
                    onVariantChange();
                }
            }

            if (e.target.closest('.product-qty-minus')) {
                const btn = e.target.closest('.product-qty-minus');
                const input = btn.parentElement ? btn.parentElement.querySelector('.product-input-qty') : null;
                if (input) {
                    let qty = parseInt(input.value) || 1;
                    if (qty > 1) {
                        qty -= 1;
                        input.value = qty;
                        const hiddenQty = document.getElementById('product_qty');
                        if (hiddenQty) hiddenQty.value = qty;
                        onVariantChange();
                    }
                }
            }
        }, true);

        // Add to Cart AJAX handler
        document.addEventListener("click", function (e) {
            const addBtn = e.target.closest('.addToCart');
            if (addBtn) {
                e.preventDefault();
                const form = addBtn.closest('form') || document.getElementById('product_form');
                if (form) {
                    const formData = new FormData(form);
                    fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData
                    })
                    .then(res => res.json())
                    .then(data => {
                        document.body.classList.add('cartshown');
                        if (typeof cart_item_update === 'function') {
                            cart_item_update();
                        }
                    })
                    .catch(err => {
                        console.error('Error adding to cart', err);
                    });
                }
            }
        });

        if (!requiresSelection()) {
            onVariantChange();
            setTimeout(onVariantChange, 100);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    window.addEventListener("load", function () { if (!requiresSelection()) onVariantChange(); });
    document.addEventListener("shopify:section:load", function () { if (!requiresSelection()) onVariantChange(); });
})();
